/* ============================================================
   ATELIER COLLECTION - Phase 1 interactions (layered on Dawn facets)
   - Atelier sort dropdown -> drives the hidden #SortBy (facets.js AJAX)
   - count sync: mirror .result-count into the Atelier count chips
   - sub-collection carousel arrows / edge fades
   - SEO "read more" clamp
   - view toggle active-state (list view lands in a later phase)
   - mobile "Filters" button -> opens the existing facet drawer (fallback: scroll)
   No dependencies. Safe if any node is absent.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__acInit) return;
    root.__acInit = true;

    /* ---------- reveal ---------- */
    root.querySelectorAll('.ac-rv').forEach(function (el) {
      el.classList.add('ac-rv-in');
    });

    /* ---------- sort dropdown -> #SortBy ---------- */
    var sortWrap = root.querySelector('[data-ac-sort]');
    if (sortWrap) {
      var sortBtn = sortWrap.querySelector('[data-ac-sort-btn]');
      var sortLabel = sortWrap.querySelector('[data-ac-sort-label]');

      sortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sortWrap.classList.toggle('ac-open');
        sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(open){
          var menu=sortWrap.querySelector('.ac-adrop-menu'), rect=sortBtn.getBoundingClientRect(), below=window.innerHeight-rect.bottom-24, above=rect.top-170;
          var upward=below<180&&above>below;
          menu.style.top=upward?'auto':'calc(100% + 6px)';
          menu.style.bottom=upward?'calc(100% + 6px)':'auto';
          menu.style.maxHeight=Math.max(140,upward?above:below)+'px';
          menu.style.overflowY='auto';
        }
      });

      sortWrap.querySelectorAll('.ac-adrop-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var val = opt.getAttribute('data-val');
          sortWrap.querySelectorAll('.ac-adrop-opt').forEach(function (o) { o.classList.remove('ac-on'); });
          opt.classList.add('ac-on');
          if (sortLabel) sortLabel.textContent = opt.querySelector('.ac-lbl').textContent;
          sortWrap.classList.remove('ac-open');
          sortBtn.setAttribute('aria-expanded', 'false');

          var sel = document.getElementById('SortBy');
          if (sel && sel.value !== val) {
            sel.value = val;
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) {
          sortWrap.classList.remove('ac-open');
          sortBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- count sync (mirror .result-count) ---------- */
    var gridContainer = document.getElementById('ProductGridContainer');
    function fmtNum(t) { return (parseInt(String(t).replace(/[^0-9]/g, ''), 10) || 0).toLocaleString(); }
    function syncCount() {
      var src = gridContainer && gridContainer.querySelector('.result-count');
      if (!src) return;
      var n = fmtNum(src.textContent);
      root.querySelectorAll('[data-ac-count-n]').forEach(function (el) { el.textContent = n; });
    }
    /* comma-format the masthead/toolbar count + the Load-More progress numbers */
    root.querySelectorAll('[data-ac-count-n],[data-ac-lm-shown],[data-ac-lm-total]').forEach(function (el) {
      el.textContent = fmtNum(el.textContent);
    });
    if (gridContainer && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncCount(); });
      mo.observe(gridContainer, { childList: true, subtree: true });
      syncCount();
    }

    /* ---------- staggered card entrance on filter/sort swaps ----------
       The container's direct children only change when facets.js swaps the
       whole result set - tag the FRESH #product-grid so its cards play the
       quick ac-card-in stagger (observer callbacks run before paint, so the
       backwards-fill hides delayed cards from the first frame). Never fires
       on initial page load (no class until the first swap) - LCP untouched.
       Load-More appends inherit the class already present on the grid, so
       newly loaded cards ease in too without re-animating existing ones. */
    if (gridContainer && 'MutationObserver' in window) {
      /* ---------- CURATED band exit + continuity (2026-08-20) ----------
         The band is the tallest element in the container, so letting the
         swap delete it in one frame read as a harsh vanish + content jump.
         When loading starts (.ac-swap/.loading lands on .collection) the
         band pre-collapses during the skeleton window IF the incoming state
         hides it: FacetFiltersForm.searchParamsPrev is assigned before
         showLoading, and the test mirrors the results snippet's Liquid gate
         (any list filter active; price_range alone does not trip
         active_values, so price is excluded here too - the predictor must
         never disagree with the server). */
      var bandSeen = !!gridContainer.querySelector('.ac-featured');
      var bandWillHide = function () {
        var qs = FFF && FFF.searchParamsPrev;
        if (!qs) return false;
        var hit = false;
        try {
          new URLSearchParams(qs).forEach(function (v, k) {
            if (k.indexOf('filter.') === 0 && k.indexOf('filter.v.price') !== 0) hit = true;
          });
        } catch (e) {}
        return hit;
      };
      var bandOut = function () {
        var band = gridContainer.querySelector('.ac-featured');
        if (!band || band.__acOut || !bandWillHide()) return;
        band.__acOut = true;
        band.style.height = band.offsetHeight + 'px';
        band.style.overflow = 'hidden';
        band.style.transition = 'height .4s cubic-bezier(.25,.8,.25,1),opacity .28s ease,margin .4s cubic-bezier(.25,.8,.25,1),padding .4s cubic-bezier(.25,.8,.25,1)';
        void band.offsetWidth;
        band.style.height = '0px';
        band.style.opacity = '0';
        band.style.marginTop = '0'; band.style.marginBottom = '0';
        band.style.paddingTop = '0'; band.style.paddingBottom = '0';
      };
      /* .collection is replaced by every swap - re-attach its class watcher
         from the childList observer below */
      var watchSwapLoad = function () {
        var col = gridContainer.querySelector('.collection');
        if (!col || col.__acBandObs) return;
        col.__acBandObs = true;
        new MutationObserver(function () {
          if (col.classList.contains('ac-swap') || col.classList.contains('loading')) bandOut();
        }).observe(col, { attributes: true, attributeFilter: ['class'] });
      };
      /* ---------- CURATED band auto-carousel (mobile, 2026-08-20) ----------
         The phone band is a one-row snap rail; auto-advance IS the "there is
         more" signal (Chris: no indicator needed if it moves). One interval
         per band instance: it self-clears when its row leaves the DOM (every
         facets swap rebuilds the band, and the swap observer re-arms the new
         one). First touch/wheel on the row retires the auto for that
         instance - never fight a user who has taken the wheel. Width and
         reduced-motion are checked per tick, not at arm time, so a rotation
         across 767px behaves without needing a resize listener. */
      var featAuto = function () {
        var row = gridContainer.querySelector('.ac-featured .ac-frow');
        if (!row || row.__acAuto) return;
        row.__acAuto = true;
        var mqMob = window.matchMedia ? window.matchMedia('(max-width:767px)') : null;
        var mqRed = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
        var seen = true;
        if ('IntersectionObserver' in window) {
          seen = false;
          new IntersectionObserver(function (es) {
            es.forEach(function (en) { seen = en.isIntersecting; });
          }, { threshold: 0.4 }).observe(row);
        }
        var t = null;
        var stop = function () { if (t) { clearInterval(t); t = null; } };
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
          row.addEventListener(ev, stop, { passive: true });
        });
        t = setInterval(function () {
          if (!row.isConnected) { stop(); return; }
          if (!seen || document.hidden) return;
          if (!mqMob || !mqMob.matches || (mqRed && mqRed.matches)) return;
          var card = row.querySelector('.ac-fcard');
          if (!card) return;
          var gap = parseFloat(getComputedStyle(row).columnGap) || 10;
          var step = card.offsetWidth + gap;
          var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - step * 0.5;
          if (atEnd) row.scrollTo({ left: 0, behavior: 'smooth' });
          else row.scrollBy({ left: step, behavior: 'smooth' });
        }, 3600);
      };
      watchSwapLoad();
      featAuto();
      new MutationObserver(function () {
        var g = document.getElementById('product-grid');
        if (g && !g.classList.contains('ac-stagger')) g.classList.add('ac-stagger');
        /* re-arm the reveal on swapped-in .ac-rv content (the CURATED band):
           init() adds ac-rv-in once at page load, so a band re-rendered by a
           later swap sat at the reveal's hidden state forever - invisible but
           full height, i.e. permanent whitespace. The layout read commits the
           hidden "from" state (callbacks run before paint) so the return
           plays the rise; a band arriving while one was ALREADY showing
           (sort change, no filters) appears transition-less instead, so it
           reads as the same band, not a re-entrance pump. */
        var hadBand = bandSeen;
        bandSeen = !!gridContainer.querySelector('.ac-featured');
        gridContainer.querySelectorAll('.ac-rv:not(.ac-rv-in)').forEach(function (el) {
          if (hadBand) {
            el.style.transition = 'none';
            el.classList.add('ac-rv-in');
            void el.offsetWidth;
            el.style.transition = '';
          } else {
            void el.offsetWidth;
            el.classList.add('ac-rv-in');
          }
        });
        watchSwapLoad();
        featAuto();
      }).observe(gridContainer, { childList: true });
    }

    /* ---------- sub-collection carousel ---------- */
    var carousel = root.querySelector('[data-ac-carousel]');
    if (carousel) {
      var carRow = carousel.querySelector('[data-ac-cat-row]');
      var prev = carousel.querySelector('[data-ac-cat-prev]');
      var next = carousel.querySelector('[data-ac-cat-next]');
      var bar = carousel.querySelector('[data-ac-cat-bar]');
      var barTh = bar && bar.querySelector('.ac-cat-bar-th');
      function updateCar() {
        if (!carRow) return;
        var atStart = carRow.scrollLeft <= 2;
        var atEnd = carRow.scrollLeft + carRow.clientWidth >= carRow.scrollWidth - 2;
        carousel.classList.toggle('ac-at-start', atStart);
        carousel.classList.toggle('ac-at-end', atEnd);
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
        if (bar && barTh) {
          var maxScroll = carRow.scrollWidth - carRow.clientWidth;
          if (maxScroll > 1) {
            bar.style.display = '';
            var frac = Math.max(carRow.clientWidth / carRow.scrollWidth, 0.14);
            var p = carRow.scrollLeft / maxScroll;
            barTh.style.width = (frac * 100) + '%';
            barTh.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
          } else {
            bar.style.display = 'none';
          }
        }
      }
      function step(dir) {
        if (!carRow) return;
        carRow.scrollBy({ left: dir * Math.max(carRow.clientWidth * 0.7, 200), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (carRow) carRow.addEventListener('scroll', updateCar, { passive: true });
      /* the touch progress bar is visible only WHILE the row is moving (Chris, 2026-08-27):
         a cut tile already says "scrollable"; the bar's job is "how far", which only
         matters mid-drag. ac-scrolling lands on the first scroll event and lifts 700ms
         after the last one; CSS fades the bar on that class and keeps its height, so
         nothing below the row moves. */
      var barIdle = null;
      function barLive() {
        carousel.classList.add('ac-scrolling');
        clearTimeout(barIdle);
        barIdle = setTimeout(function () { carousel.classList.remove('ac-scrolling'); }, 700);
      }
      if (carRow) carRow.addEventListener('scroll', barLive, { passive: true });
      window.addEventListener('resize', updateCar);
      updateCar();
    }

    /* ---------- Shop-by-finish swatches -> AJAX filter (graceful) ----------
       Swatches are plain links OUTSIDE <facet-filters-form>, so a click would normally
       navigate (reload). Route them through Dawn's FacetFiltersForm.renderPage (same path
       its "remove filter" pills use) to filter in place. CRITICAL: a click must NEVER be
       a dead end - if that engine is missing, throws, or simply doesn't re-render the grid
       (some customized themes don't AJAX cleanly), we fall back to a real navigation so the
       filter still applies. renderPage doesn't touch this rail, so after each grid render
       we re-derive the swatch active-state + toggle href from the LIVE URL (renderPage
       pushStates it synchronously) - the slim AJAX section (atelier-collection-ajax,
       2026-08-19) doesn't render the chrome, so fetched HTML no longer carries the rail.
       Nodes are patched in place so shimmer listeners survive.
       NB: a top-level `class` is a lexical global, NOT a window property - resolve it bare. */
    var FFF = (typeof FacetFiltersForm !== 'undefined') ? FacetFiltersForm : (window.FacetFiltersForm || null);
    var finRail = root.querySelector('.ac-finrail');
    if (finRail && gridContainer && FFF && typeof FFF.renderPage === 'function' && 'MutationObserver' in window) {

      finRail.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        var link = e.target.closest('.ac-fin-it');
        if (!link || !finRail.contains(link)) return;
        var key = link.getAttribute('data-fk');
        var val = link.getAttribute('data-fv');
        /* No data hooks or no AJAX engine -> let the link navigate (server applies it). */
        if (!key || !val || !document.querySelector('facet-filters-form')) return;
        e.preventDefault();

        /* Build the next query from the LIVE url, not the swatch href. renderPage updates
           the url synchronously (pushState), so successive clicks accumulate correctly -
           this is what makes multi-select stick even mid-fetch (the hrefs go stale after an
           AJAX render; the url does not). We toggle ONLY this finish's value, preserving
           every other active filter + sort. */
        var params = new URLSearchParams(window.location.search);
        var vals = params.getAll(key);
        var wasActive = vals.indexOf(val) !== -1;
        params.delete(key);
        vals.forEach(function (v) { if (v !== val) params.append(key, v); });
        if (!wasActive) params.append(key, val);
        var qs = params.toString();
        var targetUrl = window.location.pathname + (qs ? '?' + qs : '');

        /* Optimistic feedback: flip the selected ring immediately (syncFinRail reconciles
           with the server state after the render). */
        link.classList.toggle('ac-on', !wasActive);

        /* bar choreography: adding a finish can be the 0->1 filter (slide the
           ghost bar open now); removing one can be the last filter standing
           (the computed target params are the truth - slide closed if empty) */
        if (!wasActive) {
          openBarGhost();
        } else {
          var anyLeft = false;
          params.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') anyLeft = true; });
          if (!anyLeft) closeBar();
        }

        /* Reverse-direction sync: if we just DESELECTED a finish, remove its matching chip
           from the applied-filters bar NOW (match by label) instead of waiting on the slow
           re-render. (Selecting adds a chip - that appears with the results on render.) */
        if (wasActive) {
          var swLbl = (link.getAttribute('aria-label') || link.getAttribute('title') || '').trim();
          var bar = root.querySelector('.ac-active');
          if (swLbl && bar) {
            bar.querySelectorAll('.afp-chips .afp').forEach(function (chip) {
              var t = chip.querySelector('.afp-t');
              if (t && t.textContent.trim() === swLbl) {
                var fr = chip.closest('facet-remove') || chip;
                fr.style.display = 'none';
              }
            });
          }
        }

        /* Generous fallback: only a genuine hang/failure should ever reload. A slow-but-
           working fetch (the section is heavy to render) is normal - the skeleton covers it,
           and the guard observer cancels the fallback the instant the grid swaps in. */
        var settled = false;
        var fallback = setTimeout(function () { if (!settled) { settled = true; window.location.href = targetUrl; } }, 8000);
        var guard = new MutationObserver(function () { settled = true; clearTimeout(fallback); guard.disconnect(); });
        guard.observe(gridContainer, { childList: true });
        try {
          FFF.toggleActiveFacets();
          FFF.renderPage(qs);
        } catch (err) {
          if (!settled) { settled = true; clearTimeout(fallback); guard.disconnect(); window.location.href = targetUrl; }
        }
      });

      function syncFinRail() {
        /* URL = the single source of truth (renderPage pushStates it before the
           grid swaps, and popstate renders arrive with it already changed).
           active-state: is this swatch's value in the current params; href: the
           toggle of exactly this value with everything else preserved - the
           same computation the click handler makes, so hrefs never go stale. */
        var params;
        try { params = new URLSearchParams(window.location.search); } catch (err) { return; }
        finRail.querySelectorAll('.ac-fin-it').forEach(function (cur) {
          var key = cur.getAttribute('data-fk');
          var val = cur.getAttribute('data-fv');
          if (!key || !val) return;
          var vals = params.getAll(key);
          var active = vals.indexOf(val) !== -1;
          cur.classList.toggle('ac-on', active);
          var p = new URLSearchParams(window.location.search);
          p.delete(key);
          vals.forEach(function (v) { if (v !== val) p.append(key, v); });
          if (!active) p.append(key, val);
          p.delete('page');
          var qs = p.toString();
          cur.setAttribute('href', window.location.pathname + (qs ? '?' + qs : ''));
        });
      }
      new MutationObserver(syncFinRail).observe(gridContainer, { childList: true });
    }

    /* ---------- applied-filter chips -> remove instantly (optimistic) ----------
       The chips live in .active-facets-desktop, which Dawn's facet-remove ALSO wires to
       renderPage - but with no optimistic feedback and no fallback, so removal felt laggy
       (the chip lingered for seconds) and sometimes silently failed. We pre-empt Dawn's
       handler (capture phase + stopPropagation, since FacetRemove listens on the chip's <a>
       at target phase), hide the chip immediately, then route through renderPage with the
       same graceful fallback as the swatches. facets.js' renderActiveFacets keeps these chip
       hrefs fresh, so using the href is safe. .ac-active persists across re-renders (only its
       innerHTML is swapped), so this delegated listener survives. */
    var acActive = root.querySelector('.ac-active');
    if (acActive && gridContainer && FFF && typeof FFF.renderPage === 'function' && 'MutationObserver' in window) {
      acActive.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        var link = e.target.closest('.afp, .afp-clear');
        if (!link || !acActive.contains(link) || !link.href) return;
        if (!document.querySelector('facet-filters-form')) return;
        e.preventDefault();
        e.stopPropagation();

        var isClearAll = link.classList.contains('afp-clear');

        /* optimistic: also deselect the matching SHOP BY FINISH swatch(es) NOW, so the rail
           updates instantly instead of waiting on (or missing) the post-render syncFinRail.
           Read the chip label BEFORE removing the chip; match the swatch by aria-label/title. */
        if (isClearAll) {
          root.querySelectorAll('.ac-fin-it.ac-on').forEach(function (s) { s.classList.remove('ac-on'); });
        } else {
          var lblEl = link.querySelector('.afp-t');
          var lbl = lblEl ? lblEl.textContent.trim() : '';
          if (lbl) {
            root.querySelectorAll('.ac-fin-it').forEach(function (s) {
              if ((s.getAttribute('aria-label') || s.getAttribute('title') || '').trim() === lbl) s.classList.remove('ac-on');
            });
          }
        }

        /* optimistic: "Clear all" slides the bar closed; a single chip hides
           itself at once - and if it was the LAST visible chip, the whole bar
           slides closed too (the head alone isn't worth the height) */
        if (isClearAll) {
          closeBar();
        } else {
          var chip = link.closest('facet-remove') || link;
          chip.style.display = 'none';
          var anyVisible = false;
          acActive.querySelectorAll('.afp-chips .afp').forEach(function (c) {
            var fr = c.closest('facet-remove') || c;
            if (fr.style.display !== 'none') anyVisible = true;
          });
          if (!anyVisible) closeBar();
        }

        var href = link.href;
        var qs = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
        var settled = false;
        var fallback = setTimeout(function () { if (!settled) { settled = true; window.location.href = href; } }, 8000);
        var guard = new MutationObserver(function () { settled = true; clearTimeout(fallback); guard.disconnect(); });
        guard.observe(gridContainer, { childList: true });
        try {
          FFF.toggleActiveFacets();
          FFF.renderPage(qs);
        } catch (err) {
          if (!settled) { settled = true; clearTimeout(fallback); guard.disconnect(); window.location.href = href; }
        }
      }, true);
    }

    /* ---------- FILTERED-BY bar slide choreography (2026-08-19) ----------
       The bar only exists when filters are active, so 0 -> 1 filters used to
       POP it in when the response landed (the layout jank Chris flagged).
       Now the space opens AT CLICK TIME as intentional motion: a ghost bar
       (head + shimmer chip, same skeleton language as the cards) slides open
       during the skeleton phase and the real chips replace it on render.
       Unticking the last filter / Clear all slides it closed at click, with
       content kept during the collapse (.ac-closing) so the slide is smooth.
       GHOST_BAR mirrors atelier-active-pills' .afp-in structure - keep in
       sync. Functions are declarations (hoisted) - the pills/finrail handlers
       above call them. */
    var barCloseT = null;
    var GHOST_BAR = '<div class="afp-in"><div class="afp-panel">'
      + '<div class="afp-head"><span class="afp-lead"><svg viewBox="0 0 24 24"><path d="M3 5h18M6 12h12M10 19h4"/></svg><span class="afp-lead-t">Filtered by</span></span></div>'
      + '<div class="afp-chips"><span class="afp-ghost"></span></div>'
      + '</div></div>';
    function openBarGhost() {
      if (!acActive) return;
      clearTimeout(barCloseT);
      acActive.classList.remove('ac-closing');
      if (acActive.childElementCount === 0) acActive.innerHTML = GHOST_BAR;
    }
    function closeBar() {
      if (!acActive || acActive.childElementCount === 0) return;
      acActive.classList.add('ac-closing');
      clearTimeout(barCloseT);
      barCloseT = setTimeout(function () {
        acActive.innerHTML = '';
        acActive.classList.remove('ac-closing');
      }, 260);
    }
    function railHasFilters() {
      var form = document.getElementById('FacetFiltersForm');
      if (!form) return false;
      if (form.querySelector('input[type="checkbox"]:checked')) return true;
      var g = form.querySelector('input[name="filter.v.price.gte"]');
      var l = form.querySelector('input[name="filter.v.price.lte"]');
      return !!((g && g.value !== '') || (l && l.value !== ''));
    }
    function reconcileBar() {
      if (railHasFilters()) openBarGhost();
      else closeBar();
    }
    /* rail checkbox ticks arrive as 'change'; the price slider commits by
       dispatching 'input' on the gte box */
    root.addEventListener('change', function (e) {
      if (e.target.closest('#FacetsWrapperDesktop')) reconcileBar();
    });
    root.addEventListener('input', function (e) {
      var n = e.target && e.target.name;
      if (n === 'filter.v.price.gte' || n === 'filter.v.price.lte') reconcileBar();
    });

    /* ---------- finish-rail scroll indicator (mobile) ----------
       Mirrors the catnav progress bar: the thumb reflects scroll position, and the bar
       hides itself whenever the row fits (no overflow) - so it only appears when there
       are actually more swatches than fit on screen. */
    var finBarRow = root.querySelector('.ac-fin-row');
    var finBar = root.querySelector('[data-ac-fin-bar]');
    var finBarTh = finBar && finBar.querySelector('.ac-fin-bar-th');
    if (finBarRow && finBar && finBarTh) {
      var updateFinBar = function () {
        var maxScroll = finBarRow.scrollWidth - finBarRow.clientWidth;
        if (maxScroll > 1) {
          finBar.style.display = '';
          var frac = Math.max(finBarRow.clientWidth / finBarRow.scrollWidth, 0.14);
          var p = finBarRow.scrollLeft / maxScroll;
          finBarTh.style.width = (frac * 100) + '%';
          finBarTh.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
        } else {
          finBar.style.display = 'none';
        }
      };
      finBarRow.addEventListener('scroll', updateFinBar, { passive: true });
      window.addEventListener('resize', updateFinBar);
      updateFinBar();
    }

    /* ---------- finish-rail shimmer (entrance stagger + hover re-fire) ---------- */
    var finRow = root.querySelector('.ac-fin-row');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Skip the live-metal shimmer on touch/tablet - the blend-mode reflections are too
       paint-heavy on mobile and starve the header logo animation during scroll. CSS also
       hides the shine layers <=980; this avoids the JS reflows (void offsetWidth) too. */
    var noShimmer = window.matchMedia && window.matchMedia('(max-width:980px)').matches;
    if (finRow && !reduceMotion && !noShimmer) {
      var finItems = Array.prototype.slice.call(finRow.querySelectorAll('.ac-fin-it'));
      var fire = function (it) { it.classList.remove('ac-play'); void it.offsetWidth; it.classList.add('ac-play'); };
      finItems.forEach(function (it) {
        it.addEventListener('mouseenter', function () { fire(it); });
      });
      var stagger = function () { finItems.forEach(function (it, i) { setTimeout(function () { fire(it); }, i * 120); }); };
      if ('IntersectionObserver' in window) {
        var fired = false;
        var finIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !fired) { fired = true; stagger(); finIO.disconnect(); }
          });
        }, { threshold: 0.2 });
        finIO.observe(finRow);
      } else {
        stagger();
      }
    }

    /* ---------- SEO clamp ----------
       The toggle is server-rendered whenever a description exists, but many
       collections carry only a short heading - nothing overflows the 128px
       clamp, so "Read more" had nothing to reveal. Measure and hide the whole
       clamp treatment (button + fade) when the content fits. The block lives
       inside #ProductGridContainer, which facet renders swap wholesale - the
       click is therefore delegated from the section root, and the fit check
       re-runs on every grid render. */
    function fitSeoClamp() {
      var clamp = root.querySelector('[data-ac-clamp]');
      var toggle = root.querySelector('[data-ac-clamp-toggle]');
      if (!clamp || !toggle) return;
      if (clamp.classList.contains('ac-open')) return;
      var fits = clamp.scrollHeight <= clamp.clientHeight + 2;
      clamp.classList.toggle('ac-fit', fits);
      toggle.style.display = fits ? 'none' : '';
    }
    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ac-clamp-toggle]');
      if (!toggle) return;
      var clamp = root.querySelector('[data-ac-clamp]');
      if (!clamp) return;
      var open = clamp.classList.toggle('ac-open');
      toggle.textContent = toggle.getAttribute(open ? 'data-read-less' : 'data-read-more') + (open ? ' ↑' : ' ↓');
      toggle.setAttribute('aria-expanded', String(open));
      if (!open && toggle.getBoundingClientRect().top < 100) toggle.scrollIntoView({block:'center',behavior:'instant'});
    });
    fitSeoClamp();
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(fitSeoClamp);
    var seoFitT;
    window.addEventListener('resize', function () { clearTimeout(seoFitT); seoFitT = setTimeout(fitSeoClamp, 150); });
    if (gridContainer && 'MutationObserver' in window) {
      new MutationObserver(fitSeoClamp).observe(gridContainer, { childList: true });
    }

    /* ---------- grid / list view toggle (persisted) ---------- */
    var viewWrap = root.querySelector('[data-ac-view]');
    if (viewWrap) {
      var applyView = function (v) {
        root.setAttribute('data-ac-current-view', v);
        viewWrap.querySelectorAll('button[data-view]').forEach(function (b) {
          b.classList.toggle('ac-on', b.getAttribute('data-view') === v);
        });
      };
      viewWrap.querySelectorAll('button[data-view]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-view');
          applyView(v);
          try { localStorage.setItem('ac-view', v); } catch (e) {}
        });
      });
      var saved = null;
      try { saved = localStorage.getItem('ac-view'); } catch (e) {}
      if (window.location.hash === '#list') saved = 'list';
      if (saved === 'list' || saved === 'grid') applyView(saved);
    }

    /* ---------- card finish-dot hover image-swap (delegated; survives AJAX) ---------- */
    root.addEventListener('mouseover', function (e) {
      var dot = e.target.closest('.pc-fin');
      if (!dot || !root.contains(dot)) return;
      var fimg = dot.getAttribute('data-fimg');
      if (!fimg) return;
      var card = dot.closest('.pc');
      var img = card && card.querySelector('.pc-im img.main');
      if (!img) return;
      if (!img.dataset.mainSrc) img.dataset.mainSrc = img.getAttribute('src');
      img.setAttribute('src', fimg);
    });
    root.addEventListener('mouseout', function (e) {
      /* Restore when the mouse leaves the swatch ROW (.pc-fins), in ANY direction.
         Key off the row, not the dot, so exiting upward off a swatch still restores.
         Only skip the restore when the mouse is still heading inside the SAME row
         (sibling swatch or the gap between them) - that prevents the between-swatch flash. */
      var fromFins = e.target.closest && e.target.closest('.pc-fins');
      if (!fromFins || !root.contains(fromFins)) return;
      var toFins = (e.relatedTarget && e.relatedTarget.closest) ? e.relatedTarget.closest('.pc-fins') : null;
      if (toFins === fromFins) return;
      var card = fromFins.closest('.pc');
      var img = card && card.querySelector('.pc-im img.main');
      if (img && img.dataset.mainSrc) img.setAttribute('src', img.dataset.mainSrc);
    });

    /* ---------- filter rail: accordion toggle (delegated; survives AJAX) ----------
       Order, auto-open default, and metal-gradient finish swatches are all rendered
       in Liquid (atelier-facets.liquid), so JS only handles open/close on header click. */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('.fg-q');
      if (!q || !root.contains(q)) return;
      var group = q.closest('.fgroup');
      if (!group) return;
      var open = group.classList.toggle('on');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    var bsdExpandedFacets = new Set();
    function bsdCompactFacets() {
      root.querySelectorAll('[data-bsd-compact-facet]').forEach(function (wrap) {
        var group = wrap.closest('.js-filter');
        var groupId = group ? group.id : '';
        var rows = Array.from(wrap.children).filter(function (el) { return el.tagName === 'LABEL'; });
        var more = wrap.querySelector('[data-bsd-facet-more]');
        if (wrap.hasAttribute('data-bsd-numeric-facet')) {
          rows.sort(function (a, b) {
            function rank(row) {
              var label = row.querySelector('.lbl');
              var text = label ? label.textContent.trim() : '';
              var number = text.match(/\d+(?:\.\d+)?/);
              if (!number) return Number.MAX_SAFE_INTEGER;
              return parseFloat(number[0]) - (/^Under/i.test(text) ? 0.5 : 0);
            }
            return rank(a) - rank(b);
          });
          rows.forEach(function (row) { wrap.insertBefore(row, more); });
        }
        var extra = 0;
        rows.forEach(function (row, index) {
          var input = row.querySelector('input');
          var hidden = index >= 8 && !(input && input.checked);
          row.classList.toggle('bsd-facet-extra', hidden);
          if (hidden) extra += 1;
        });
        var expanded = bsdExpandedFacets.has(groupId);
        wrap.classList.toggle('bsd-facet-expanded', expanded);
        if (more) {
          more.hidden = extra === 0;
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = more.getAttribute(expanded ? 'data-less-text' : 'data-more-text');
        }
      });
    }
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bsd-facet-more]');
      if (!button || !root.contains(button)) return;
      var wrap = button.closest('[data-bsd-compact-facet]');
      var group = button.closest('.js-filter');
      if (!wrap || !group) return;
      var expanded = !wrap.classList.contains('bsd-facet-expanded');
      if (expanded) bsdExpandedFacets.add(group.id);
      else bsdExpandedFacets.delete(group.id);
      bsdCompactFacets();
    });
    document.addEventListener('bsd:filters-ready', bsdCompactFacets);
    bsdCompactFacets();

    /* ---------- filter-row prefetch (perf pass 2026-08-19) ----------
       Hover-intent (65ms) or pointerdown on a rail row starts the slim-section
       fetch for the state a click WOULD produce, so by the time the click's
       debounced submit runs, the response is cached or already in flight
       (facets.js fetchSection dedupes by URL - no double requests).
       The would-be query string MUST byte-match onSubmitHandler's desktop
       serialization: same forms, same DOM order, same createSearchParams -
       we flip the row's checkbox for the serialization instant and flip it
       back (synchronous, no paint in between). Disabled (greyed) rows are
       skipped - clicking them does nothing, so warming them is waste. */
    var pfTimer = null, pfLabel = null;
    function buildDesktopQs(toggleInput) {
      var fEl = document.querySelector('facet-filters-form');
      if (!fEl || typeof fEl.createSearchParams !== 'function') return null;
      var was = toggleInput.checked;
      toggleInput.checked = !was;
      var parts = [];
      document.querySelectorAll('facet-filters-form form').forEach(function (form) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          parts.push(fEl.createSearchParams(form));
        }
      });
      toggleInput.checked = was;
      return parts.join('&');
    }
    function prefetchRow(label) {
      if (!FFF || typeof FFF.prefetchParams !== 'function') return;
      var inp = label.querySelector('input[type="checkbox"]');
      if (!inp || inp.disabled) return;
      var qs = buildDesktopQs(inp);
      if (qs != null) FFF.prefetchParams(qs);
    }
    var PF_ROWS = '#FacetsWrapperDesktop .fopt, #FacetsWrapperDesktop .fsw, #FacetsWrapperDesktop .fsh, #FacetsWrapperDesktop .fbr';
    root.addEventListener('pointerover', function (e) {
      var label = e.target.closest(PF_ROWS);
      if (!label || !root.contains(label) || label === pfLabel) return;
      clearTimeout(pfTimer);
      pfLabel = label;
      pfTimer = setTimeout(function () { prefetchRow(label); }, 65);
    });
    root.addEventListener('pointerout', function (e) {
      var label = e.target.closest(PF_ROWS);
      if (!label || label !== pfLabel) return;
      if (e.relatedTarget && label.contains(e.relatedTarget)) return; /* still inside the row */
      clearTimeout(pfTimer);
      pfLabel = null;
    });
    root.addEventListener('pointerdown', function (e) {
      var label = e.target.closest(PF_ROWS);
      if (!label || !root.contains(label)) return;
      clearTimeout(pfTimer);
      prefetchRow(label);
    });

    /* ---------- mobile filter drawer (Atelier floating panel) ---------- */
    var rail = root.querySelector('.ac-rail');
    var scrim = root.querySelector('[data-ac-fscrim]');
    var openDrawer = function () {
      if (rail) { rail.inert = false; rail.classList.add('ac-open'); rail.setAttribute('role','dialog'); rail.setAttribute('aria-modal','true'); rail.setAttribute('aria-hidden','false'); }
      if (filterOpen) filterOpen.setAttribute('aria-expanded','true');
      requestAnimationFrame(function(){var close = rail && rail.querySelector('[data-ac-filter-close]');if(close) close.focus({preventScroll:true});});
      if (scrim) scrim.classList.add('ac-on');
      document.body.classList.add('ac-drawer-lock');
    };
    var closeDrawer = function () {
      var wasOpen = rail && rail.classList.contains('ac-open');
      if (rail) { rail.classList.remove('ac-open'); rail.removeAttribute('aria-modal'); rail.removeAttribute('role'); if (window.matchMedia('(max-width:980px)').matches) {rail.inert=true;rail.setAttribute('aria-hidden','true');} }
      if (filterOpen) filterOpen.setAttribute('aria-expanded','false');
      if (wasOpen && filterOpen) filterOpen.focus({preventScroll:true});
      if (scrim) scrim.classList.remove('ac-on');
      document.body.classList.remove('ac-drawer-lock');
    };
    var filterOpen = root.querySelector('[data-ac-filter-open]');
    if (filterOpen) filterOpen.addEventListener('click', openDrawer);
    if (scrim) scrim.addEventListener('click', function () {
      /* paired brand-finishes mode: the rail is away and this scrim is serving
         the brand panel - a tap steps back to the filter pane, it doesn't tear
         the whole stack down (bfAway/bfClose live in the brand block below) */
      if (bfAway) { bfClose(); return; }
      closeDrawer();
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ac-filter-close]')) {
        closeDrawer();
        if(e.target.closest('button[data-bsd-show-results]')) window.scrollTo({top:0,left:0,behavior:'instant'});
      }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !bfAway) closeDrawer();
    });

    function bsdFilterText(key, count) {
      return (root.getAttribute('data-bsd-' + key.replace(/_/g,'-')) || '').replace('__count__', count == null ? '' : count);
    }
    function bsdFilterState(loading) {
      var inputs = root.querySelectorAll('#FacetFiltersForm input[type="checkbox"]:checked');
      var count = inputs.length;
      var prices = root.querySelectorAll('#FacetFiltersForm input[name^="filter.v.price."]');
      if (Array.from(prices).some(function(i){return i.value !== '';})) count += 1;
      var badge = root.querySelector('[data-bsd-filter-count]');
      if (badge) {badge.textContent=count;badge.hidden=!count;}
      var result = gridContainer && gridContainer.querySelector('.result-count');
      var n = result ? fmtNum(result.textContent) : '0';
      var show = root.querySelector('[data-bsd-show-results]');
      if (show) {show.disabled=!!loading;show.textContent=loading?bsdFilterText('updating'):bsdFilterText('show_results',n);}
      var status = root.querySelector('[data-bsd-filter-status]');
      if(status) status.textContent=loading?bsdFilterText('updating'):(n==='0'?bsdFilterText('empty'):(count?bsdFilterText('selected',count):''));
      if (rail) rail.setAttribute('aria-busy',String(!!loading));
    }
    function bsdRailViewport() {
      if (!rail) return;
      var mobile = window.matchMedia('(max-width:980px)').matches;
      rail.inert = mobile && !rail.classList.contains('ac-open');
      if(mobile) rail.setAttribute('aria-hidden',String(!rail.classList.contains('ac-open')));
      else {rail.removeAttribute('aria-hidden');rail.removeAttribute('aria-modal');rail.removeAttribute('role');}
    }
    bsdRailViewport();
    window.matchMedia('(max-width:980px)').addEventListener('change',bsdRailViewport);
    document.addEventListener('bsd:filters-loading',function(){bsdFilterState(true);});
    document.addEventListener('bsd:filters-ready',function(){
      bsdFilterState(false);
      var value=new URLSearchParams(window.location.search).get('sort_by') || root.getAttribute('data-bsd-default-sort');
      var select=document.getElementById('SortBy');
      if(select&&value)select.value=value;
      if(sortWrap)sortWrap.querySelectorAll('.ac-adrop-opt').forEach(function(option){
        var selected=option.getAttribute('data-val')===value;
        option.classList.toggle('ac-on',selected);option.setAttribute('aria-selected',String(selected));
        if(selected&&sortLabel)sortLabel.textContent=option.querySelector('.ac-lbl').textContent;
      });
    });
    root.addEventListener('change',function(e){if(e.target.closest('#FacetFiltersForm')) bsdFilterState(true);});
    root.addEventListener('click',function(e){
      var clear=e.target.closest('[data-bsd-filter-clear]');
      if(!clear || !FFF || typeof FFF.renderPage!=='function') return;
      e.preventDefault();
      root.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(function(input){input.checked=false;});
      root.querySelectorAll('#FacetFiltersForm input[name^="filter.v.price."]').forEach(function(input){input.value='';});
      var params=new URLSearchParams(window.location.search);
      Array.from(params.keys()).forEach(function(key){if(key.indexOf('filter.')===0 || key==='page')params.delete(key);});
      FFF.renderPage(params.toString(),null);
    });
    if(rail) rail.addEventListener('keydown',function(e){
      if(e.key!=='Tab'||!rail.classList.contains('ac-open')||rail.classList.contains('ac-away'))return;
      var items=Array.from(rail.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')).filter(function(el){return el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden';});
      if(!items.length)return;
      var first=items[0],last=items[items.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    bsdFilterState(false);

    /* ---------- header active-count chips (spec 2026-08-17) ----------
       Crimson chip on a group header only when that group has active filters.
       Checked state is Liquid-rendered, so recount after load, after any tick,
       and after every facets.js AJAX swap (observer below). */
    var recountActs = function () {
      root.querySelectorAll('#FacetsWrapperDesktop .fgroup').forEach(function (g) {
        var act = g.querySelector('[data-ac-act]');
        if (!act) return;
        var n = g.querySelectorAll('input[type="checkbox"]:checked').length;
        var gte = g.querySelector('input[name="filter.v.price.gte"]');
        var lte = g.querySelector('input[name="filter.v.price.lte"]');
        if (gte || lte) {
          var hasPrice = (gte && gte.value !== '') || (lte && lte.value !== '');
          if (hasPrice) n = 1;
        }
        act.textContent = n;
        act.classList.toggle('show', n > 0);
      });
    };
    root.addEventListener('change', function (e) {
      if (e.target.closest('#FacetsWrapperDesktop')) recountActs();
    });

    /* ---------- price range slider (in-trial 2026-08-17) ----------
       Progressive enhancement over the Dawn price inputs: the slider writes the
       gte/lte values and fires a bubbling input event, so facets.js's debounced
       submit runs exactly as if the user typed. Dynamic floor = the collection's
       cheapest price, read once from a cheapest-first section render and cached
       per collection for the session; any failure falls back to a $0 floor, and
       if this code never runs the classic Lowest/Highest boxes stay visible. */
    var fmtMoney = function (n) { return '$' + n.toLocaleString('en-AU'); };
    var niceStep = function (span) {
      var raw = span / 50;
      var pow = Math.pow(10, Math.floor(Math.log10(raw)));
      var steps = [1, 2, 2.5, 5, 10];
      for (var i = 0; i < steps.length; i++) {
        if (raw <= steps[i] * pow) return steps[i] * pow;
      }
      return 10 * pow;
    };
    var buildPriceSlider = function (el, cheapest) {
      var form = el.closest('form');
      var gte = form.querySelector('input[name="filter.v.price.gte"]');
      var lte = form.querySelector('input[name="filter.v.price.lte"]');
      var rangeMax = parseFloat(el.dataset.rangeMax);
      if (!gte || !lte || !rangeMax || rangeMax <= cheapest) return;
      var step = niceStep(rangeMax - cheapest);
      var lo = Math.floor(cheapest / step) * step;
      var hi = Math.ceil(rangeMax / step) * step;
      var a = parseFloat(String(gte.value).replace(/[^0-9.]/g, ''));
      var b = parseFloat(String(lte.value).replace(/[^0-9.]/g, ''));
      a = isNaN(a) ? lo : Math.min(hi, Math.max(lo, Math.round(a / step) * step));
      b = isNaN(b) ? hi : Math.min(hi, Math.max(lo, Math.round(b / step) * step));
      if (b - a < step) { a = Math.max(lo, b - step); }
      var nSteps = Math.round((hi - lo) / step);
      el.innerHTML = '<div class="fp-read" data-fp-read></div>'
        + '<div class="fp-sl">'
        + '<div class="fp-track"></div><div class="fp-fill" data-fp-fill></div>'
        + '<input type="range" class="fp-min" data-fp-min min="' + lo + '" max="' + hi + '" step="' + step + '" value="' + a + '" aria-label="Minimum price">'
        + '<input type="range" class="fp-max" data-fp-max min="' + lo + '" max="' + hi + '" step="' + step + '" value="' + b + '" aria-label="Maximum price">'
        + '</div>'
        + '<div class="fp-ticks" style="background-size:calc(100% / ' + nSteps + ') 100%"></div>';
      var minI = el.querySelector('[data-fp-min]');
      var maxI = el.querySelector('[data-fp-max]');
      var read = el.querySelector('[data-fp-read]');
      var fill = el.querySelector('[data-fp-fill]');
      var upd = function (mover, commit) {
        var va = +minI.value, vb = +maxI.value;
        if (vb - va < step) {
          if (mover === minI) { va = Math.max(lo, vb - step); minI.value = va; }
          else { vb = Math.min(hi, va + step); maxI.value = vb; }
        }
        read.textContent = fmtMoney(va) + ' – ' + fmtMoney(vb);
        var f1 = (va - lo) / (hi - lo), f2 = (vb - lo) / (hi - lo);
        fill.style.left = 'calc(9px + (100% - 18px) * ' + f1 + ')';
        fill.style.right = 'calc(9px + (100% - 18px) * ' + (1 - f2) + ')';
        minI.classList.toggle('fp-top', va > lo + (hi - lo) * 0.6);
        if (commit) {
          gte.value = va > lo ? va : '';
          lte.value = vb < hi ? vb : '';
          gte.dispatchEvent(new Event('input', { bubbles: true }));
          recountActs();
        }
      };
      minI.addEventListener('input', function () { upd(minI, false); });
      maxI.addEventListener('input', function () { upd(maxI, false); });
      minI.addEventListener('change', function () { upd(minI, true); });
      maxI.addEventListener('change', function () { upd(maxI, true); });
      upd(minI, false);
      el.classList.add('fp-ready');
    };
    var initPriceSlider = function () {
      var el = root.querySelector('[data-ac-price-slider]');
      if (!el || el.dataset.acInited) return;
      el.dataset.acInited = '1';
      var floorKey = 'acPriceFloor:' + el.dataset.handle;
      var cached = parseFloat(sessionStorage.getItem(floorKey));
      if (!isNaN(cached)) { buildPriceSlider(el, cached); return; }
      var done = false;
      var fallback = setTimeout(function () {
        if (!done) { done = true; buildPriceSlider(el, 0); }
      }, 2500);
      fetch(el.dataset.fetchUrl + '&section_id=' + el.dataset.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (done) return;
          done = true;
          clearTimeout(fallback);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var now = doc.querySelector('.pc-pr .now');
          var v = now ? parseFloat(now.textContent.replace(/[^0-9.]/g, '')) : 0;
          if (isNaN(v) || v < 0) v = 0;
          if (v > 0) sessionStorage.setItem(floorKey, v);
          buildPriceSlider(el, v);
        })
        .catch(function () {
          if (!done) { done = true; clearTimeout(fallback); buildPriceSlider(el, 0); }
        });
    };

    /* ---------- Brand finishes tier + drawer (option B, 2026-08-19) ----------
       The S&D custom.brand_finishes filter never renders as a rail group: its
       checkboxes live in a hidden .js-filter group ([data-ac-bf-group]) and the
       visible UI is the tier row at the foot of Finish plus this drawer. The
       drawer is BUILT FRESH on every open from the hidden group (AJAX swaps can
       never leave it stale) and appended to document.body (a transformed
       ancestor would break position:fixed inside the mobile rail). Apply writes
       the selection into the hidden inputs and fires ONE bubbling input event
       from inside that group, so facets.js treats it as the group's own change:
       renderCounts only on it, every other group re-renders, tier included. */
    /* [key, section heading, nav-chip label] - chips stay one word so the row
       doesn't wrap inside the 430px drawer */
    /* Tonal order, light -> dark; it MUST match the fam_idx ladder in
       snippets/atelier-brand-finishes.liquid. Empty families are skipped when
       the drawer renders, so a vendor only ever sees the sections it has:
       cabinet decors fill whites/greys/oaks/walnuts/blacks, basin colours fill
       creams/stones/greens. 'greys' lost its "& Green" tail when greens became
       a family of their own - Topiary stays a grey, so no cabinet finish moved. */
    var BF_FAMS = [
      ['whites', 'Whites', 'Whites'], ['creams', 'Creams & Sands', 'Creams'],
      ['greys', 'Greys', 'Greys'], ['stones', 'Stones & Marbles', 'Stones'],
      ['oaks', 'Oaks & Light Woods', 'Oaks'], ['walnuts', 'Walnuts & Dark Woods', 'Walnuts'],
      ['greens', 'Greens', 'Greens'], ['blacks', 'Blacks', 'Blacks'],
      ['other', 'More finishes', 'More']
    ];
    var bfEl = null;
    var bfScrim = null;
    var bfPending = null;   /* ALL checked values, every vendor - see bfApply */
    var bfBrand = '';
    /* true while the drawer was opened from the OPEN mobile filter pane: the
       pane slides away left as the drawer arrives right (paired motion), and
       the pane's scrim keeps serving both so the tint never doubles */
    var bfAway = false;
    var bfEsc = function (s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : s;
      return d.innerHTML;
    };
    /* host-agnostic: the rows sit either in the hidden group or inside the
       synthetic Finish group (builder-only collections) - query the rows
       themselves, never their wrapper */
    var bfItems = function (brand) {
      var needle = ',' + brand + ',';
      var items = [];
      root.querySelectorAll('label.acbf-src').forEach(function (l) {
        var inp = l.querySelector('input[type="checkbox"]');
        var lbl = l.querySelector('.lbl');
        if (!inp || !lbl) return;
        var brands = l.dataset.brands || '';
        if (brand && (',' + brands + ',').indexOf(needle) === -1) return;
        items.push({
          /* IDENTITY = vendor field + value, never the value alone. One entry
             per real finish means a finish both vendors offer is the SAME
             metaobject GID in both filters, so a GID-only key made ticking it
             in one drawer select it in the other and apply both filters. */
          key: inp.name + '|' + inp.value,
          label: lbl.textContent,
          value: inp.value,
          checked: inp.checked,
          count: parseInt(l.dataset.count, 10) || 0,
          family: l.dataset.family || 'other',
          brands: brands,
          swatch: l.dataset.swatch || '',
          vg: l.dataset.vg === '1',
          sort: parseFloat(l.dataset.sort) || 999
        });
      });
      return items;
    };
    /* NOTE (2026-08-20): a live "Show N products" count on the apply button
       was built and REMOVED same day - each candidate count needed a slim-twin
       section render (counts cannot be summed client-side: the OR-union is not
       the sum of value counts), and per-tick renders proved slow enough to
       feel sluggish (section rendering is throttled). Don't rebuild it on the
       same mechanism; it needs a cheap count source that doesn't exist today. */
    var bfCurItems = null;   /* key -> item for the OPEN vendor (strip render) */
    /* footer = selected shelf (this vendor's picks as removable swatches) +
       Clear (hidden until something is picked) + the static Show button.
       bfPending also holds the other vendor's picks, which Apply preserves. */
    var bfCount = function () {
      if (!bfEl) return;
      var strip = bfEl.querySelector('[data-bf-sel]');
      var picks = [];
      if (bfCurItems) bfPending.forEach(function (k) { if (bfCurItems[k]) picks.push(bfCurItems[k]); });
      /* on empty the STALE chips stay in the DOM and the shelf closes over
         them - wiping them first snaps the content height mid-animation,
         which is what made the close look janky vs the open */
      if (strip && picks.length) {
        strip.innerHTML = picks.map(function (it) {
          return '<button type="button" class="acbf-pk" data-bf-unpick="' + bfEsc(it.key) + '"'
            + ' aria-label="Remove ' + bfEsc(it.label) + '" title="' + bfEsc(it.label) + '"'
            + (it.swatch ? ' style="background-image:url(\'' + it.swatch + '\')"' : '') + '>'
            + '<span class="rm"><svg viewBox="0 0 24 24"><path d="M7 7l10 10M17 7 7 17"/></svg></span>'
            + '</button>';
        }).join('');
      }
      var clr = bfEl.querySelector('[data-bf-clear]');
      if (clr) clr.hidden = !picks.length;
      /* the shelf slides open with the first pick, closed with the last -
         no sticky whitespace above the buttons when nothing is selected */
      var band = bfEl.querySelector('[data-bf-selband]');
      if (band) band.classList.toggle('on', !!picks.length);
    };
    var bfClose = function (exitAll) {
      if (!bfEl) return;
      bfEl.classList.remove('acbf-on');
      if (bfScrim) bfScrim.classList.remove('acbf-on');
      if (!bfAway) return;
      bfAway = false;
      /* the paired return: drawer exits right while the filter pane slides
         back in from the left on the same clock. exitAll (Apply) leaves the
         whole stack instead - the pane is parked at the same off-left
         position as its closed home, so dropping ac-away + ac-open together
         is jump-free and closeDrawer releases the scrim + body lock. */
      if (rail) rail.classList.remove('ac-away');
      if (exitAll) closeDrawer();
    };
    var bfApply = function () {
      var inputs = root.querySelectorAll('label.acbf-src input[type="checkbox"]');
      if (!inputs.length) { bfClose(); return; }
      var changed = false;
      var firstInput = null;
      inputs.forEach(function (i) {
        if (!firstInput) firstInput = i;
        var want = bfPending.has(i.name + '|' + i.value);
        if (i.checked !== want) { i.checked = want; changed = true; }
      });
      /* Apply means "show me the products" (Chris 2026-08-20): on mobile it
         exits the whole stack straight to the grid; back/X/scrim still step
         back to the filter pane. Desktop unchanged (grid sits beside). */
      bfClose(true);
      if(window.matchMedia('(max-width:980px)').matches) window.scrollTo({top:0,left:0,behavior:'instant'});
      if (changed && firstInput) {
        firstInput.dispatchEvent(new Event('input', { bubbles: true }));
        recountActs();
      }
    };
    var bfShell = function () {
      if (bfEl) return bfEl;
      /* scrim + floating panel as SIBLINGS, matching the cart / side-nav
         drawer family (.ct-drawer, .at-mdrawer): 12px inset, 22px radius,
         warm scrim. The scrim is an intentionally-empty styled div, so it
         carries an id for the #id{display:block} override AND a child node -
         the store hides empty divs (app-css-gotchas, 6 prior hits). */
      bfScrim = document.createElement('div');
      bfScrim.className = 'acbf-scrim';
      bfScrim.id = 'acbfScrim';
      bfScrim.innerHTML = '<i></i>';
      document.body.appendChild(bfScrim);
      bfEl = document.createElement('aside');
      bfEl.className = 'acbf';
      bfEl.setAttribute('role', 'dialog');
      bfEl.setAttribute('aria-modal', 'true');
      bfEl.setAttribute('aria-label', 'Brand finishes');
      /* class names here live at BODY level (the portal) - every one must be
         acbf-prefixed or unique. A bare "row" got Bootstrap's .row from the
         collection bridge css (negative side margins crushed the header
         padding to ~2px on phones). The close button carries both glyphs;
         .acbf-back (paired mobile mode) swaps the X for the back chevron. */
      bfEl.innerHTML = '<div class="acbf-hd"><div class="acbf-row">'
        + '<span class="acbf-logo" data-bf-logo></span>'
        + '<div class="tt"><h3 data-bf-title></h3></div>'
        + '<button type="button" class="acbf-x" data-bf-close aria-label="Close">'
        + '<svg class="acbf-gx" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>'
        + '<svg class="acbf-gb" viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg>'
        + '</button></div>'
        + '<div class="acbf-nav" data-bf-nav></div></div>'
        + '<div class="acbf-bd" data-bf-body></div>'
        + '<div class="acbf-selband" data-bf-selband><div class="acbf-selclip"><div class="acbf-sel" data-bf-sel></div></div></div>'
        + '<div class="acbf-ft">'
        + '<button type="button" class="acbf-clear" data-bf-clear hidden>Clear</button>'
        + '<button type="button" class="acbf-apply" data-bf-apply>Show results</button></div>';
      document.body.appendChild(bfEl);
      bfScrim.addEventListener('click', bfClose);
      bfEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-bf-close]')) { bfClose(); return; }
        var chip = e.target.closest('[data-bf-fam]');
        if (chip) {
          var sec = bfEl.querySelector('.acbf-fam[data-fam="' + chip.dataset.bfFam + '"]');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          bfEl.querySelectorAll('[data-bf-fam]').forEach(function (b) { b.classList.toggle('on', b === chip); });
          return;
        }
        var pk = e.target.closest('[data-bf-unpick]');
        if (pk) {
          var uk = pk.getAttribute('data-bf-unpick');
          bfPending.delete(uk);
          bfEl.querySelectorAll('.acbf-card.sel').forEach(function (c) {
            if (c.dataset.value === uk) c.classList.remove('sel');
          });
          /* let the chip's scale-out play before the strip rebuild wipes it */
          pk.classList.add('out');
          setTimeout(bfCount, 150);
          return;
        }
        var card = e.target.closest('.acbf-card');
        if (card) {
          var v = card.dataset.value;
          if (bfPending.has(v)) bfPending.delete(v); else bfPending.add(v);
          card.classList.toggle('sel', bfPending.has(v));
          bfCount();
          return;
        }
        if (e.target.closest('[data-bf-clear]')) {
          /* clears THIS vendor's picks only - the other vendor's stay applied */
          bfEl.querySelectorAll('.acbf-card.sel').forEach(function (c) {
            bfPending.delete(c.dataset.value);
            c.classList.remove('sel');
          });
          bfCount();
          return;
        }
        if (e.target.closest('[data-bf-apply]')) bfApply();
      });
      return bfEl;
    };
    var bfOpen = function (btn) {
      bfBrand = btn.dataset.bfBrand || '';
      var items = bfItems(bfBrand);
      if (!items.length) return;
      bfCurItems = {};
      items.forEach(function (it) { bfCurItems[it.key] = it; });
      var el = bfShell();
      /* seed from EVERY checked value, not just this vendor's, so applying
         here never silently drops the other vendor's active finishes */
      bfPending = new Set();
      bfItems('').forEach(function (it) { if (it.checked) bfPending.add(it.key); });
      /* title comes from the vendor's own filter label (Chris renames it in
         Search & Discovery); data-bf-brand is the stable key, not the label */
      var title = btn.dataset.bfTitle || (bfBrand + ' finishes');
      var logo = el.querySelector('[data-bf-logo]');
      var logoSrc = btn.dataset.bfLogo || '';
      logo.innerHTML = logoSrc
        ? '<img src="' + logoSrc + '" alt="' + bfEsc(title) + '">'
        : '';
      logo.hidden = !logoSrc;
      el.querySelector('[data-bf-title]').textContent = title;
      var nav = '';
      var body = '';
      var groups = BF_FAMS.map(function (fam) {
        return [fam, items.filter(function (it) { return it.family === fam[0]; })];
      }).filter(function (g) { return g[1].length; });
      /* Family sections earn their keep on a real range - they give a tonal
         reading order and something for the chips to jump to. On a short one
         they degrade into a stack of one-card sections with more heading than
         swatch (Fienza's five decors land in five different families), so a
         small vendor gets one plain grid and no chip row instead. Neither
         shipped vendor is affected: ADP has 43 and Ovia 11. */
      var grouped = items.length >= 8
        && groups.some(function (g) { return g[1].length > 1; });
      if (!grouped) groups = [[['all', '', ''], items]];
      groups.forEach(function (g) {
        var fam = g[0], list = g[1];
        list.sort(function (a, b) { return a.sort - b.sort || a.label.localeCompare(b.label); });
        if (grouped) {
          nav += '<button type="button" data-bf-fam="' + fam[0] + '">' + fam[2] + '</button>';
        }
        body += '<section class="acbf-fam" data-fam="' + fam[0] + '">'
          + (grouped
              ? '<div class="fh"><b>' + fam[1] + '</b><small>' + list.length + '</small></div>'
              : '')
          + '<div class="acbf-grid">'
          + list.map(function (it) {
              var dis = it.count === 0 && !it.checked;
              /* Square tile + tick = the Vanity Builder's swatch markup
                 (vb-swatch / vb-swatch__check), same 16px SVG, so choosing a
                 finish here matches choosing one in the builder.
                 The brand is never printed on a card: the drawer is already
                 one vendor's, and "ADP · Ovia" on a shared finish would tell
                 customers the two share a cabinet range (in-house knowledge) */
              return '<div class="acbf-card' + (bfPending.has(it.key) ? ' sel' : '') + (dis ? ' dis' : '')
                + '" data-value="' + bfEsc(it.key) + '">'
                + '<span class="tx"' + (it.swatch ? ' style="background-image:url(\'' + it.swatch + '\')"' : '') + '>'
                + '<span class="ck"><svg width="16" height="16" viewBox="0 0 20 20" fill="none">'
                + '<circle cx="10" cy="10" r="10" fill="#c41230"/>'
                + '<path d="M6 10l3 3 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
                + '</svg></span></span>'
                + '<b>' + bfEsc(it.label) + '</b>'
                + '<span class="meta"><span class="ct">' + it.count + '</span>'
                + (it.vg ? '<span class="vg">V-Groove</span>' : '') + '</span>'
                + '</div>';
            }).join('')
          + '</div></section>';
      });
      el.querySelector('[data-bf-nav]').innerHTML = nav;
      var firstChip = el.querySelector('[data-bf-fam]');
      if (firstChip) firstChip.classList.add('on');
      el.querySelector('[data-bf-body]').innerHTML = body;
      el.querySelector('[data-bf-body]').scrollTop = 0;
      bfCount();
      /* the page deliberately stays scrollable behind the drawer - same as the
         side-nav/cart drawers (no scroll lock, no scrollbar layout jump), so a
         wheel outside the panel still moves the page. On mobile the drawer is
         opened from INSIDE the open filter pane instead: pane away left +
         drawer in right as one paired motion, on the pane's own scrim (raising
         a second scrim would double the tint). position:fixed is the honest
         "the pane is a drawer right now" test - ac-open can linger across a
         resize to desktop, where the rail is a static column. */
      bfAway = !!(rail && rail.classList.contains('ac-open')
        && getComputedStyle(rail).position === 'fixed');
      /* paired mode: the button STEPS BACK to the filter pane rather than
         dismissing, so it wears the chevron, not the X */
      el.classList.toggle('acbf-back', bfAway);
      var xb = el.querySelector('[data-bf-close]');
      if (xb) xb.setAttribute('aria-label', bfAway ? 'Back to filters' : 'Close');
      if (bfAway) {
        rail.classList.add('ac-away');
      } else if (bfScrim) {
        bfScrim.classList.add('acbf-on');
      }
      el.classList.add('acbf-on');
    };
    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ac-bf-open]');
      if (openBtn) bfOpen(openBtn);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && bfEl && bfEl.classList.contains('acbf-on')) bfClose();
    });

    /* facets.js AJAX swaps .js-filter contents (except the group the user touched)
       - re-arm the chips and, when the price group was rebuilt, the slider */
    var facetsWrap = root.querySelector('#FacetsWrapperDesktop');
    if (facetsWrap) {
      var moTimer;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          recountActs();
          initPriceSlider();
        }, 60);
      }).observe(facetsWrap, { childList: true, subtree: true });
    }
    recountActs();
    initPriceSlider();
  }

  function boot() {
    document.querySelectorAll('.atelier-collection').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================================
   BACK-RESTORE for the collection page - port of the /search system, with
   BOTH iOS paths learned the hard way there (see atelier-search.js + memory
   atelier-search-progress):
   - bfcache RESUME (Safari when its cache holds): page returns alive but at
     the top, because scrollRestoration=manual also suppresses Safari scroll
     restore on resume -> pageshow persisted=true re-applies the saved scroll.
   - full RELOAD: detection ladder = navtype back_forward -> {acr:1} history
     stamp (MERGED into state - facets.js stores searchParams there) ->
     outbound localStorage marker (single-shot, 30min TTL). Snapshot written
     at CARD-CLICK time (iOS drops pagehide-time writes), keys NORMALISED
     (params sorted; transport params stripped) because iOS restores the
     PRE-replaceState entry URL. Restore re-fetches pages 2..N in PARALLEL via
     the Section Rendering API and adopts the LAST page's .ac-loadmore block
     (progress bar + counts + button state, all server-computed).
   Guarded to the real collection page: this asset also loads on PDP rails.
   ========================================================================== */
(function () {
  'use strict';
  if (!document.getElementById('ProductGridContainer') || !document.getElementById('product-grid')) return;

  var TTL = 1800000; /* 30min */
  function stGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function stSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function stDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  var DBG = /(\?|&)asrdebug=1/.test(location.search);
  var dbgEl = null;
  function dbgShow(line) {
    if (!dbgEl) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:8px;bottom:8px;right:8px;z-index:999999;background:rgba(20,21,24,.92);color:#7ee0a8;font:10px/1.5 monospace;padding:8px 10px;border-radius:8px;white-space:pre-wrap;max-height:45vh;overflow:auto;pointer-events:none';
      (document.body || document.documentElement).appendChild(dbgEl);
    }
    dbgEl.textContent += line + '\n';
    dbgEl.scrollTop = dbgEl.scrollHeight;
  }
  function dbg(line) {
    var stamped = new Date().toTimeString().slice(0, 8) + ' C ' + line;
    try {
      var L = (localStorage.getItem('asr_dbg') || '').split('\n').filter(Boolean);
      L.push(stamped);
      localStorage.setItem('asr_dbg', L.slice(-24).join('\n'));
    } catch (e) {}
    if (DBG) dbgShow(stamped);
  }
  if (/(\?|&)asrclear=1/.test(location.search)) { stDel('asr_dbg'); stDel('acr_out'); stDel('acr_snap'); }
  if (DBG) {
    var prior = stGet('asr_dbg');
    if (prior) {
      var pl = prior.split('\n');
      if (pl.length > 10) prior = '(... ' + (pl.length - 10) + ' older lines trimmed ...)\n' + pl.slice(-10).join('\n');
      dbgShow('---- prior log ----\n' + prior + '\n---- this load ----');
    }
  }

  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  /* canonical key: filter/sort params only, SORTED - iOS restores the
     PRE-replaceState entry URL, and facet param order can vary */
  function keyOf() {
    var p = new URLSearchParams(location.search);
    p.delete('asrdebug'); p.delete('asrclear'); p.delete('page'); p.delete('section_id');
    var kv = []; p.forEach(function (v, k) { kv.push(k + '=' + v); });
    kv.sort();
    return location.pathname + '?' + kv.join('&');
  }
  function lmBtn() { return document.querySelector('.load-more-btn'); }
  function curPages() {
    var b = lmBtn();
    return b ? (parseInt(b.getAttribute('data-current-page'), 10) || 1) : 1;
  }
  function takeSnapshot() {
    stSet('acr_snap', JSON.stringify({
      key: keyOf(), t: Date.now(),
      scrollY: window.scrollY || window.pageYOffset || 0,
      pages: curPages(),
      sid: (lmBtn() && lmBtn().getAttribute('data-section-id')) || ''
    }));
  }
  function isBackNav() {
    try {
      var t = '';
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (n && n[0]) t = n[0].type;
      else if (performance.navigation) t = performance.navigation.type === 2 ? 'back_forward' : (performance.navigation.type === 1 ? 'reload' : 'navigate');
      if (t === 'back_forward') return true;
      if (t === 'reload') return false;
      if (history.state && history.state.acr === 1) return true;
      var out = +stGet('acr_out') || 0;
      if (out && Date.now() - out < TTL) return true;
      return false;
    } catch (e) { return false; }
  }
  function jump(y) {
    var de = document.documentElement, prevSB = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
      requestAnimationFrame(function () { window.scrollTo(0, y); de.style.scrollBehavior = prevSB; });
    });
    setTimeout(function () {
      if (Math.abs((window.scrollY || 0) - y) > 40) window.scrollTo(0, y);
      dbg('landed=' + Math.round(window.scrollY) + ' target=' + y);
    }, 600);
  }
  function pageUrl(k, sid) {
    var p = new URLSearchParams(location.search);
    p.delete('asrdebug'); p.delete('asrclear');
    p.set('page', k); p.set('section_id', sid);
    return location.pathname + '?' + p.toString();
  }
  function tryRestore() {
    var nt = ''; try { var nn = performance.getEntriesByType('navigation'); nt = nn && nn[0] ? nn[0].type : '(none)'; } catch (eD) { nt = '(err)'; }
    dbg('IN navtype=' + nt + ' state=' + JSON.stringify(history.state) + ' marker=' + (stGet('acr_out') || 'none'));
    var back = isBackNav();
    stDel('acr_out'); /* single-shot, spent on every evaluation */
    dbg('isBackNav=' + back);
    if (!back) return;
    var snap; try { snap = JSON.parse(stGet('acr_snap') || 'null'); } catch (e) {}
    if (!snap) { dbg('no snapshot'); return; }
    if (snap.t && Date.now() - snap.t > TTL) { dbg('snapshot expired'); return; }
    if (snap.key !== keyOf()) { dbg('key mismatch\n  saved  ' + snap.key + '\n  actual ' + keyOf()); return; }
    var pages = Math.min(Math.max(1, snap.pages || 1), 10); /* depth cap */
    dbg('RESTORING pages=' + pages + ' scrollY=' + snap.scrollY);
    if (pages <= 1) { jump(snap.scrollY || 0); return; }
    var b = lmBtn();
    var sid = (b && b.getAttribute('data-section-id')) || snap.sid;
    if (!sid) { jump(snap.scrollY || 0); return; }
    var reqs = [];
    for (var k = 2; k <= pages; k++) {
      reqs.push(fetch(pageUrl(k, sid)).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; }));
    }
    Promise.all(reqs).then(function (docs) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      var lastDoc = null;
      for (var i = 0; i < docs.length; i++) {
        if (!docs[i]) { dbg('page ' + (i + 2) + ' fetch failed'); continue; }
        var doc = new DOMParser().parseFromString(docs[i], 'text/html');
        var cols = doc.querySelectorAll('#product-grid .col');
        for (var c = 0; c < cols.length; c++) grid.appendChild(cols[c]);
        lastDoc = doc;
      }
      /* adopt the LAST page's server-rendered Load-More block: progress bar,
         Showing X of N, button page-state / hidden-at-end - no bookkeeping */
      if (lastDoc) {
        var freshLm = lastDoc.querySelector('.ac-loadmore');
        var curLm = document.querySelector('.ac-loadmore');
        if (freshLm && curLm) {
          curLm.parentNode.replaceChild(freshLm, curLm);
          ['[data-ac-lm-shown]', '[data-ac-lm-total]'].forEach(function (sel) {
            var el = freshLm.querySelector(sel);
            if (el) { var v = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10); if (v) el.textContent = v.toLocaleString(); }
          });
        }
      }
      jump(snap.scrollY || 0);
    });
  }

  /* card-click = the primary snapshot moment (iOS drops pagehide writes).
     Re-query the container each time - facet renders swap that block. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var c = document.getElementById('ProductGridContainer');
    if (!c || !c.contains(a)) return;
    dbg('OUT -> ' + a.href + ' scrollY=' + Math.round(window.scrollY) + ' pages=' + curPages());
    takeSnapshot();
    /* MERGE the stamp - facets.js keeps its searchParams in history.state */
    try { history.replaceState(Object.assign({}, history.state || {}, { acr: 1 }), '', location.href); } catch (e2) {}
    stSet('acr_out', String(Date.now()));
  }, true);
  window.addEventListener('pagehide', takeSnapshot);

  /* bfcache resume: page returns alive but at the top (scrollRestoration=
     manual suppresses Safari scroll restore) - re-apply the saved scroll.
     READ-ONLY on the restore signals (see the /search lesson). */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    dbg('pageshow persisted=true');
    if ((window.scrollY || 0) > 40) { dbg('resume: browser kept scroll'); return; }
    var snap; try { snap = JSON.parse(stGet('acr_snap') || 'null'); } catch (e2) {}
    if (!snap || snap.key !== keyOf() || !snap.scrollY) { dbg('resume: no matching snapshot'); return; }
    jump(snap.scrollY);
  });

  tryRestore();
})();
